import { useApi } from '@/api';
import type { GetTopProductsResponse } from '@/api/handlers/resources/sales/responses/GetTopProductsResponse';
import type { ApiResponse } from '@/api/handlers/responses/ApiResponse';
import { useQuery } from '@tanstack/react-query';
import { SalesQueryKeys } from './salesQueryKeys';

export type UseTopProductsQueryParams = {
    from: string;
    to: string;
};

/**
 * Top-products query. The `queryKey` carries `from` / `to` so changing
 * the page-level period filter triggers a refetch automatically.
 */
export const useTopProductsQuery = (
    params: UseTopProductsQueryParams,
    enabled = true,
) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetTopProductsResponse>>({
        queryKey: SalesQueryKeys.topProducts(params.from, params.to),
        queryFn: () =>
            apiClient.sales.getTopProducts({
                from: params.from,
                to: params.to,
            }),
        enabled,
        staleTime: 60_000,
    });
};
